import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import {
  AdriaticInfoModalStyles,
  CloseButton,
  LeftSide,
  ModalBody,
  ModalContent,
  ModalHeader,
  PreContractPill,
  RightSide,
  TextContainer,
  TitleBox,
} from './AdriaticInfoModal.styles';
import preContractIcon from '../../../../assets/redesign_icons/pre-contract-icon.svg';
import infoIcon from '../../../../assets/redesign_icons/info-icon.svg';
import { downloadResourceDocs } from '../../../../services/axios-client/axeCommons';

function TutelaInfoModal({ setShowModal, quotation }) {
  const closeModal = () => setShowModal(false);

  const title = 'Informazioni';

  return (
    <AdriaticInfoModalStyles>
      <ModalBody>
        <ModalHeader>
          <LeftSide>
            <TextContainer>
              <TitleBox>
                <img src={infoIcon} alt="Info" />
                <h3>{title}</h3>
              </TitleBox>
              <p>Qui puoi controllare le informazioni su questa offerta.</p>
            </TextContainer>
          </LeftSide>

          <RightSide>
            {quotation?.sub_product === 'patente_motor' ? (
              <PreContractPill
                onClick={() => downloadResourceDocs(37, 0)}
                title="Informativa Precontrattuale"
              >
                <img src={preContractIcon} alt="" />
                <p>Informativa Precontrattuale</p>
              </PreContractPill>
            ) : quotation?.sub_product === 'nucleo_famigliare' ? (
              <PreContractPill
                onClick={() => downloadResourceDocs(38, 0)}
                title="Informativa Precontrattuale"
              >
                <img src={preContractIcon} alt="" />
                <p>Informativa Precontrattuale</p>
              </PreContractPill>
            ) : quotation?.product_id === 11 ? (
              <PreContractPill
                onClick={() => downloadResourceDocs(39, 0)}
                title="Informativa Precontrattuale"
              >
                <img src={preContractIcon} alt="" />
                <p>Informativa Precontrattuale</p>
              </PreContractPill>
            ) : null}
          </RightSide>
          <CloseButton onClick={closeModal} aria-label="Chiudi">
            <FontAwesomeIcon icon={faTimes} />
          </CloseButton>
        </ModalHeader>

        <ModalContent>
          <div className="card-extra-information">

            {quotation?.sub_product === 'patente_motor' && (
              <>
                <h3>Che cosa è assicurato</h3>
                <p>
                  L’assicurazione copre spese per legali, periti, consulenti tecnici,
                  legale domiciliatario, spese in caso di soccombenza, transazioni
                  autorizzate dalla Società, accertamenti, indagini per la ricerca di
                  prove, redazione di denunce e querele, arbitrati, mediazione, contributo
                  unificato, spese di giustizia, registrazione atti e assistenza interprete
                  in caso di arresto.
                </p>

                <h3>Pacchetto A – Tutela Motor</h3>
                <ul>
                  <li>Recupero danni da illecito di terzi</li>
                  <li>Controversie contrattuali riguardanti il veicolo</li>
                  <li>Difesa penale per delitti colposi / contravvenzioni connesse a incidenti</li>
                  <li>Omicidio stradale / lesioni gravi o gravissime</li>
                  <li>Delitti dolosi (salvo assoluzione)</li>
                  <li>Dissequestro del veicolo</li>
                  <li>Anticipo cauzione penale all’estero</li>
                  <li>Assistenza interprete all’estero</li>
                  <li>Opposizione a sanzioni su patente post-incidente</li>
                  <li>Controversie con Compagnie infortuni</li>
                  <li>Opposizione sanzioni per furto targa / clonazione</li>
                  <li>Ricorso codice della strada (solo se accolto)</li>
                  <li>Ricorso variazione punti patente</li>
                </ul>

                <h3>Pacchetto B Plus</h3>
                <ul>
                  <li>Rimborso corso recupero punti patente</li>
                  <li>Rimborso revisione patente</li>
                </ul>

                <h3>Cosa non è assicurato</h3>
                <ul>
                  <li>Spese per documenti</li>
                  <li>Multe, ammende, sanzioni</li>
                  <li>Pene detentive</li>
                  <li>Eventi bellici, terrorismo, sommosse</li>
                  <li>Guida in stato di ebbrezza (&gt;1,5g/l) o sotto stupefacenti</li>
                  <li>Veicolo usato in difformità dalla carta di circolazione</li>
                  <li>Gare sportive</li>
                </ul>
              </>
            )}

            {quotation?.sub_product === 'vita_privata' && (
              <>
                {/* <h3>Che cosa è assicurato</h3> */}
                <p>
                  Tutela legale per la sfera personale e familiare. Copre spese di difesa penale (reati colposi o contravvenzioni), controversie civili e privacy, anche per contenuti diffamatori online. Include anche atti di volontaria giurisdizione come separazioni consensuali o amministrazione di sostegno.

                </p>

                <p className="mt-4">
                  <strong className="fw-bold"> Massimale:  </strong>
                  fino a €50.000.
                </p>

              </>
            )}
            {quotation?.sub_product === 'tutela_professionale' && (
            <>
              <h5 className="fw-bold">Prodotto base: Nuova Tutela Azienda e Professionisti</h5>
              <p className="mt-3">
                <span className="fw-bold">Tipologia:</span>
                {' '}
                Assicurazione di tutela legale per aziende, professionisti e figure apicali.
              </p>

              <p className="mt-1">
                <span className="fw-bold">Finalità: </span>
                Copertura delle spese legali e peritali in ambito penale, civile e amministrativo, per la difesa dei propri diritti e interessi nell’attività professionale o d’impresa.
              </p>

              <p className="mt-3 fw-bold">Cosa copre:</p>

              <ul>
                <li>Difesa penale per delitti colposi e contravvenzioni.</li>
                <li>Difesa civile e controversie extracontrattuali.</li>
                <li>Spese di resistenza, opposizione a sanzioni amministrative, vertenze con agenti e rappresentanti.</li>
                <li>Tutela in casi di responsabilità amministrativa, concorrenza sleale e diritto d’autore.</li>

              </ul>

              <p>
                {' '}
                <span className="fw-bold">Massimali disponibili:  </span>
                €25.000 – €35.000 – €50.000 – €100.000 per sinistro (senza limite di casi per anno).
              </p>

              <p className="mt-3 fw-bold">Caratteristiche principali:</p>

              <ul>
                <li>Copertura in tutta l’UE, Svizzera, UK, Liechtenstein e Principato di Monaco.</li>
                <li>Nessuno scoperto.</li>
                <li>Garanzia postuma di 2 anni.</li>
              </ul>

              <h5 className="fw-bold mt-3"> Garanzia aggiuntiva: Figure Apicali</h5>
              <p className="mt-3">
                <span className="fw-bold">Destinatari: </span>
                {' '}
                Dirigenti, quadri, direttori generali, amministratori delegati, direttori sanitari e manager con incarichi di responsabilità, anche con compensi a gettone.
              </p>

              <p className="mt-3 fw-bold">Cosa  offre:</p>

              <ul>
                <li>Tutela legale e peritale per responsabilità derivanti dal ruolo ricoperto.</li>
                <li>Copertura per procedimenti penali e contravvenzionali anche in fase preliminare.</li>
                <li>Spese legali per assoluzione o archiviazione in caso di imputazioni dolose derubricate.</li>
                <li>Opposizione a sanzioni amministrative (es. sicurezza sul lavoro, GDPR, ambiente, sicurezza alimentare).</li>
                <li>Controversie con enti previdenziali o assistenziali.</li>
                <li>Tutela in vertenze di lavoro individuali.</li>
                <li>Difesa e richieste di risarcimento danni subiti o connessi alla circolazione stradale per motivi di lavoro.</li>

              </ul>

              <p>
                {' '}
                <span className="fw-bold">Massimali: </span>
                da €25.000 a €100.000 per evento.
              </p>
              <p>
                {' '}
                <span className="fw-bold">Periodo di carenza:  </span>
                3 mesi per vertenze contrattuali.
              </p>
              <p>
                {' '}
                <span className="fw-bold">Documenti richiesti in caso di sinistro:  </span>
                visura camerale o documentazione idonea a dimostrare il ruolo.
              </p>

              <h5 className="fw-bold mt-3"> Pacchetto “Figure Apicali” (dal prodotto NTAP1 – Aziende e Professionisti)</h5>
              <p className="mt-3">

                {' '}
                Garanzia dedicata ad
                {' '}
                <span className="fw-bold">amministratori, dirigenti, sindaci e organi di vigilanza</span>
                {' '}
                . Copre le spese legali per procedimenti civili, penali o amministrativi legati alle decisioni gestionali, incluse violazioni di legge o statuto.
              </p>

              <p className="mt-3">
                {' '}
                <span className="fw-bold ">Massimale: </span>
                secondo contratto, fino a €100.000.
              </p>

            </>
            )}

            {quotation?.product_id === 11 && (
              <>
                <h3>Che cosa è assicurato</h3>
                <p>
                  La polizza Casa protegge il Fabbricato e il Contenuto da eventi come incendio,
                  scoppio, esplosione, fumo, fulmine, danni d’acqua, eventi atmosferici,
                  socio–politici, atti vandalici, eventi naturali, guasti causati da ladri,
                  nonché responsabilità civile della proprietà e della conduzione.
                </p>

                <h3>Coperture principali</h3>
                <ul>
                  <li>
                    <strong>Incendio Fabbricato</strong>
                    {' '}
                    – Danni da incendio, scoppio, esplosione,
                    fumo ed eventi naturali.
                  </li>
                  <li>
                    <strong>Incendio Contenuto</strong>
                    {' '}
                    – Tutela dei beni presenti nell’abitazione.
                  </li>
                  <li>
                    <strong>Responsabilità Civile Fabbricato</strong>
                    {' '}
                    – Danni involontari a terzi.
                  </li>
                  <li>
                    <strong>Responsabilità Civile Conduzione</strong>
                    {' '}
                    – Danni causati dall’utilizzo
                    dell’abitazione.
                  </li>
                  <li>
                    <strong>Responsabilità Civile Capofamiglia</strong>
                    {' '}
                    – Danni causati dagli
                    assicurati nella vita privata.
                  </li>
                  <li>
                    <strong>Furto</strong>
                    {' '}
                    – Furto dei beni presenti nell’abitazione, scippo e
                    rapina.
                  </li>
                  <li>
                    <strong>Tutela Legale</strong>
                    {' '}
                    – Spese legali per controversie civili/penali.
                  </li>
                  <li>
                    <strong>Assistenza</strong>
                    {' '}
                    – Interventi tecnici professionali sull’abitazione.
                  </li>
                  <li>
                    <strong>Copertura Catastrofale</strong>
                    {' '}
                    – Eventi naturali straordinari come
                    terremoti e alluvioni (se prevista).
                  </li>
                  <li>
                    <strong>Life Style</strong>
                    {' '}
                    – Servizi di conciliazione e mediazione delle
                    controversie.
                  </li>
                </ul>

                <h3>Che cosa non è assicurato</h3>
                <ul>
                  <li>Danni causati da familiari conviventi.</li>
                  <li>Danni verificati fuori dai locali assicurati.</li>
                  <li>Danni provocati da colaborarori professionali.</li>
                  <li>Guerre, tumulti, eventi terroristici e nucleari.</li>
                  <li>Terremoto quando la garanzia Catastrofale non è stata acquistata.</li>
                  <li>Danni derivanti da attività professionali svolte nell’immobile.</li>
                  <li>Responsabilità derivante dalla circolazione dei veicoli.</li>
                  <li>Per gli Animali Domestici: attività sportive e animali destinati alla vendita.</li>
                </ul>

                <h3>Limitazioni di copertura</h3>
                <ul>
                  <li>
                    Le coperture sono soggette ai
                    {' '}
                    <strong>massimali</strong>
                    {' '}
                    e
                    <strong>franchigie</strong>
                    {' '}
                    indicati nel contratto.
                  </li>
                  <li>Alcune garanzie richiedono un livello minimo di danno.</li>
                  <li>I servizi di Assistenza prevedono limiti e massimali specifici.</li>
                  <li>
                    Per la Responsabilità Civile non sono garantiti i rischi derivanti dalla
                    professione dell’assicurato.
                  </li>
                </ul>

                <h3>Dove vale la copertura</h3>
                <ul>
                  <li>
                    <strong>Fabbricato, Contenuto, Furto e Assistenza</strong>
                    {' '}
                    – nel luogo indicato
                    in polizza.
                  </li>
                  <li>
                    <strong>Responsabilità Civile Capofamiglia</strong>
                    {' '}
                    – in Europa e nei Paesi
                    extra–europei che si affacciano sul Mediterraneo.
                  </li>
                </ul>

                <h3>Obblighi dell’assicurato</h3>
                <ul>
                  <li>Pagare il premio secondo le modalità previste.</li>
                  <li>Comunicare eventuali aggravamenti di rischio.</li>
                  <li>Adottare misure idonee a evitare o limitare i danni.</li>
                  <li>Denunciare il sinistro entro i termini contrattuali.</li>
                </ul>

                <h3>Quando e come pagare</h3>
                <p>
                  Il premio può essere corrisposto in unica soluzione oppure con rate semestrali
                  o mensili (se previsto). Il premio è dovuto per intero anche in caso di rateazione.
                </p>

                <h3>Durata e recesso</h3>
                <p>
                  La polizza ha durata annuale con tacito rinnovo. Puoi disdire il contratto entro
                  i termini indicati dalle condizioni generali.
                </p>
              </>

            )}
          </div>
        </ModalContent>
      </ModalBody>
    </AdriaticInfoModalStyles>
  );
}

export default TutelaInfoModal;
